import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Sharedservice } from './../../shared-components/shared.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { UploadFile, UploaderOptions, UploadInput, UploadOutput, humanizeBytes } from 'ngx-uploader';
import { environment } from 'src/environments/environment';
import { CoverIndexService } from 'src/app/services/coverindex.service';
import { UserService } from 'src/app/services/user.service';
import { UserModel } from 'src/app/models/user.model';
import { severitymessage, LanguageConstants } from '../../shared-components/constant';
import { InfraService } from 'src/app/services/infra.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { EngagementModel } from 'src/app/models/engagement.model';
import { EngagementService } from 'src/app/services/engagement.service';


@Component({
  selector: 'app-upload-databook',
  templateUrl: './upload-databook.component.html',
  styleUrls: ['./upload-databook.component.css']
})
export class UploadDatabookComponent implements OnInit {
  options: UploaderOptions;
  uploadInput: EventEmitter<UploadInput>;
  sourceFiles: UploadFile[];
  humanizeBytes: Function;
  dragOver: boolean;
  databook: any;
  downloadenable = true;
  private loggedInUserData: UserModel[];
  loadspinner = false;
  isQualityCheck = false;

  engagementId = +this.route.snapshot.paramMap.get('id');
  configUrl: string;
  downloadErrorLogConfigUrl: string;
  langCode: string;
  currLangTranslation: any;

  constructor(private infraService: InfraService, private route: ActivatedRoute,
    public sharedService: Sharedservice, private router: Router, private messageService: MessageService,
    private coverIndexService: CoverIndexService, private userService: UserService, private confirmationService: ConfirmationService, private translateService: TranslateService
    , private engagementService: EngagementService) {
    // if (localStorage.getItem('selectedregion') == '1') {
    //  this.configUrl = environment.apiUrl + 'adjustment';
    //  this.downloadErrorLogConfigUrl = environment.apiUrl + 'filedownload/databookerrorlog/' + this.engagementId;
    // }
    // else {
    //  this.configUrl = environment.apiUrlRow + 'adjustment';
    //  this.downloadErrorLogConfigUrl = environment.apiUrlRow + 'filedownload/databookerrorlog/' + this.engagementId;
    // }
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'adjustment';
      this.downloadErrorLogConfigUrl = data.WebEndPoint1 + 'filedownload/databookerrorlog/' + this.engagementId;
    });
    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData !== undefined) {

        this.loggedInUserData = [];
        this.loggedInUserData.push(userData);
      }
    });

    this.options = {
      concurrency: 1, allowedContentTypes: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/msexcel',
        'application/vnd.ms-excel',
        'application/vnd.ms-excel.sheet.macroEnabled.12']
    };
    this.sourceFiles = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader

    this.humanizeBytes = humanizeBytes;
  }


  uploaddatabook = false;

  flatedisabled = true;
  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.messageService.clear('myKey1');
    this.sharedService.CheckUserAccessForEngagement(this.engagementId);
    this.route.params.subscribe(param => {
      param['src'] === 'qualitycheck' ? this.isQualityCheck = true : this.isQualityCheck = false;
    });
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
    });
    this.getDatabookstatus();
  }

  onUploadOutput(output: UploadOutput, fileInput: any): void {
    if (this.downloadenable) {
      if (output.type === 'allAddedToQueue') { // when all files added in queue
        // uncomment this if you want to auto upload files when added
        const event: UploadInput = {
          type: 'uploadAll',
          url: this.configUrl + '/upload/' + this.engagementId + '~' + this.loggedInUserData[0].Id,
          method: 'POST',
          data: { foo: 'bar' },
          headers: { 'Authorization': 'Bearer ' + (environment.isBearerAuthorizationEnabled ? localStorage['dbamsaltoken'] : environment.sampleToken) }
        };
        this.uploadInput.emit(event);
      } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added
        this.sourceFiles.push(output.file);
      } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
        // update current data in files array for uploading file
        const index = this.sourceFiles.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
        this.sourceFiles[index] = output.file;
      } else if (output.type === 'done' && typeof output.file !== 'undefined') {
        if (this.sourceFiles[0].response.message === 'Exterror') {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.uploadDatabookComponentmessage.errorMessage.FileFormate,
            sticky: true, closable: true
          });
          this.flatedisabled = false;
        } else if (this.sourceFiles[0].response.message === 'Datacheckerror') {
          this.confirmationService.confirm({
            message: this.currLangTranslation.uploadDatabookComponentmessage.errorMessage.UploadLog,
            header: this.currLangTranslation.uploadDatabookComponentmessage.errorMessage.DataError,
            acceptLabel: this.currLangTranslation.actionButtons.yes,
            rejectLabel: this.currLangTranslation.actionButtons.no,
            accept: () => {

              event.stopPropagation();
              window.location.href = this.downloadErrorLogConfigUrl + '~' + this.loggedInUserData[0].Id;
            },
            reject: () => {
            }
          });
          this.flatedisabled = false;
        } else if (this.sourceFiles[0].response.message === 'Uploaderror') {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
          });
          this.flatedisabled = false;
        } else {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success, summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.FileUpload, sticky: true, closable: true
          });
          this.flatedisabled = true;
        }
        this.sourceFiles = [];
        fileInput.value = '';
      } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
        // Replace with Notification service
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        });
        this.flatedisabled = false;
      } else if (output.type === 'removed') {
        // remove file from array when removed
        this.sourceFiles = this.sourceFiles.filter((file: UploadFile) => file !== output.file);
      } else if (output.type === 'dragOver') {
        this.dragOver = true;
      } else if (output.type === 'dragOut') {
        this.dragOver = false;
      } else if (output.type === 'drop') {
        this.dragOver = false;
      }
    }
  }

  getDatabookstatus() {
    this.engagementService.getEngagement(this.engagementId)
      .subscribe((response: EngagementModel) => {
        this.coverIndexService.getDatabookstatus(this.engagementId, response.IsDynamicDatabook).subscribe(data => {
          this.databook = data;
          if (this.databook.length >= 1) {
            this.uploaddatabook = false;
            this.downloadenable = true;
          } else {
            this.uploaddatabook = true;
            this.downloadenable = false;
          }
        });
      });
  }
  confirmdisplaydataTab = false;
  // boolean confirmdisplaydataTab: false;
  updateAdjustment() {
    this.confirmdisplay = true;
  }

  DataTabUpdate1Event($event) {
    this.confirmdisplay = false;
    //  this.downloadUploadDatabook()
    // this.getEngagement();
  }

  // downloadUploadDatabook() {
  //  let isNewVersion = true;
  //  isNewVersion = parseInt(this.versionType.toString()) === 1 ? true : false;
  //  if (!isNewVersion) {
  //    this.coverIndexService.downloadDatabookFromBlob(this.engagementId).subscribe(blobdata => {
  //      this.loadspinner = false;
  //      if (!this.downloadDatabookWithPrompt) {
  //        this.coverIndexService.getDatabookstatus(this.engagementId).subscribe(data => {
  //          this.databook = data;
  //          this.uploaddatabook = !(this.databook.length >= 1);
  //          const databookIndex = this.databook[0].DataBookName.lastIndexOf('\\');
  //          const fileName = this.databook[0].DataBookName.substr(databookIndex + 1);
  //          if (blobdata) {
  //            saveAs(blobdata, fileName);
  //          }
  //          // window.location.href = this.configUrl;
  //          event.stopPropagation();
  //          this.downloadenable = false;
  //          return;
  //        }, error => {
  //          this.logger.info("--------error logged in schedules.component.checkDatabookalreadyExists()----------" + error);
  //        });
  //      }
  //    },
  //      error => {
  //        this.logger.info("--------error logged in schedules.component.downloadDatabook()----------" + error);
  //        this.loadspinner = false;
  //        this.downloadenable = false;
  //        this.messageService.add({
  //          key: severitymessage.key, severity: severitymessage.error,
  //          summary: severitymessage.notification,
  //          detail: severitymessage.DownloadError,
  //          sticky: true,
  //          closable: true
  //        });
  //      }
  //    );
  //  }
  //  else { this.loadspinner = false; }
  // }
  redirectToSelectAdjustment() {
    this.router.navigate(['/engagement/', this.engagementId, 'selectadjustment']);
    this.messageService.clear();
  }
  redirectToValidations() {
    this.router.navigate(['/engagement/', this.engagementId, 'validations']);
    this.messageService.clear();
  }

  confirmdisplay = false;
  closeEventworkallocation($event) {
    this.confirmdisplay = $event;
  }

  okEventworkallocation($event) {

    this.confirmdisplay = false;



  }


}
